module.exports = __webpack_public_path__ + "static/media/landing.09eee079.png";